import React, { useRef } from 'react'
import './Slider.scss'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Pagination } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

export default function Slider({
  slides,
  imgHeight,
  onSlideImageClick,
  isImageClickable = false,
}) {
  const swiperRef = useRef(null) // Create a ref to control Swiper

  return (
    <div className={`slider`}>
      <Swiper
        spaceBetween={50}
        slidesPerView={1}
        modules={[Navigation, Pagination]}
        navigation={true}
        pagination={true}
        loop={false}
        // initialSlide={1}
        onSlideChange={() => console.log('slide change')}
        onSwiper={swiper => {
          swiperRef.current = swiper
        }}>
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <img
              src={slide}
              height={imgHeight}
              className={`slide-image ${isImageClickable ? 'pointer' : 'large-image'}`}
              alt={`Slide ${index}`}
              onClick={() => {
                if (isImageClickable) {
                  onSlideImageClick(index)
                }
              }}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}
